import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-followup-calander',
  templateUrl: './followup-calander.component.html',
  styleUrls: ['./followup-calander.component.css']
})
export class FollowupCalanderComponent implements OnInit {
  ptp_start_date:""
  displayPosition: boolean;
  rows = [];
  searchQR: any;
  value1: any;
  // changes
  login_detail:any;
  getFromLocal(key): any {
    return this.storage.get(key);
  }


  userFilter: any = { Bank_Name: '',agentName:'',Customer_Name:'',passport_no:'',cif : '',acc_no : '',ptp_amount : '',ptp_status : '',log_date: '' ,mstatus : ''};

  constructor(
    private router: Router,
    private _api: ApiService,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    private datePipe: DatePipe
  ) { }

  Data:any;
  Data1:any;
  Data2:any;

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.rows = [{ type: "Dog", name: "dog1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" }]

    this.login_detail = this.getFromLocal("login_detail");
    const data = {
      user_id: this.login_detail._id
    }
 this._api.followupfilterDate(data).subscribe(data => {
  if (data['Code'] == 200) {
 this.Data = data['Data'];
    console.log("Allocation Data",  this.Data);

    this.Data.forEach((element:any) => {
let name = JSON.parse(element.user_list[0].customer_details[0]);
// console.log("Name", name);

element.PRINCIPLE_AMT = name[0].PRINCIPLE_AMT || '';
element.Bank_Name = element.bank_id.bank_name;
element.agentName = name[0]['AGENT'] || '';
element.fint_id = name[0].fint_id || '';
element.Customer_Name = name[0].Customer_Name || '';
element.passport_no = name[0].passport_no || '';
element.total_out_standing = name[0].total_out_standing || '';
element.cif = name[0].cif || '';
element.acc_no = name[0].acc_no || '';
// const dateString = element.date_of_assign;
// const dateObject = new Date(dateString);
// var text = element.date_of_allocations;
// console.log("element.date_of_assign",element.date_of_assign);

// const dateString =new Date(element.date_of_assign);
// var dateOnly = dateString.toISOString().substring(0, 10); // Returns the date in the local date format
// element.date_of_assign = dateOnly
// Format the date using DatePipe
// element.date_of_assign = this.datePipe.transform(dateObject, 'yyyy-MM-dd');

    });

    // console.log("current", this.Data1);
  } else {
    this.Data = [];
    this.Data1 = []; // Initialize Data1 as an array even if there's an error
  }
});


  }
  client_form() {
    this.router.navigateByUrl('/admin_panel/client-form')
  }
  profile() {
    this.router.navigateByUrl('/admin_panel/Client_profile')
  }

  showPositionDialog() {
    this.displayPosition = true;
}
cus360(){
  this.router.navigateByUrl('/admin_panel/user/createuser')
}

clear() {
  this.ptp_start_date = '';
}


filterdateFollowip(){
  const data = {
    user_id: this.login_detail._id,
    ptp_start_date:this.ptp_start_date
  }
this._api.followupfilterDate(data).subscribe(data => {
if (data['Code'] == 200) {
this.Data = data['Data'];
  console.log("Allocation Data",  this.Data);

  this.Data.forEach((element:any) => {
let name = JSON.parse(element.user_list[0].customer_details[0]);

element.PRINCIPLE_AMT = name[0].PRINCIPLE_AMT || '';
element.Bank_Name = element.bank_id.bank_name;
element.agentName = name[0]['AGENT'] || '';
element.fint_id = name[0].fint_id || '';
element.Customer_Name = name[0].Customer_Name || '';
element.passport_no = name[0].passport_no || '';
element.total_out_standing = name[0].total_out_standing || '';
element.cif = name[0].cif || '';
element.acc_no = name[0].acc_no || '';

  });

  // console.log("current", this.Data1);
} else {
  this.Data = [];
  this.Data1 = []; // Initialize Data1 as an array even if there's an error
}
});
}
getCustomer(page,data){
  console.log("data",data);
  let d = {
    passport_no :  data.passport_no,
    acc_no :  data.acc_no,
    bank_id : data.bank_id,
    portfolio_id : data.portfolio_id,
    product_id : data.product_id,
    customer_id: data.customer_id,
    finterstal_id: data.finterstal_id
  }
  console.log("d",d);
  this._api.fetch_customer_detail1(d).subscribe(
    (response: any) => {

      console.log("response",response);

      if (response.Data[0].customer_details[0].insert_id != undefined) {
        var test_text = response.Data[0].customer_details;
        var convDatav = test_text;
        // console.log(convDatav['length']);
        var jsonObject = convDatav[0];
        var keyCount  = Object.keys(jsonObject).length;
        // console.log(keyCount);
        let dataList = [];
        for (let i = 0; i < convDatav.length; i++) {
              for (let i = 0; i < keyCount; i++) {
                var key = Object.keys(jsonObject)[i];
                if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {

                } else {
                  var value = jsonObject[key];
                  dataList.push({column:key,row:value});
                }
              }
            }
          this.storage.set("_storedRecord",{dataList,"keyvalue":data});
          this.router.navigateByUrl(page);
      } else {
        console.log(response.Data[0].customer_details[0]);

        let datass = JSON.parse(response.Data[0].customer_details[0]);
        console.log("datass",datass);

        var test_text;
        console.log(datass[0].cif);
        console.log(response.Data[0].customer_details[0].cif);
        if(response.Data[0].customer_details[0].cif !== undefined){
          test_text = [];
          test_text.push(response.Data[0].customer_details[0]);
        }else{
          test_text = JSON.parse(response.Data[0].customer_details[0]);
        }
        let convDatav = test_text;
        // console.log(convDatav['length']);
        var jsonObject = convDatav[0];
        var keyCount  = Object.keys(jsonObject).length;
        // console.log(keyCount);
        let dataList = [];
        for (let i = 0; i < convDatav.length; i++) {
              for (let i = 0; i < keyCount; i++) {
                var key = Object.keys(jsonObject)[i];
                if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {

                } else {
                  var value = jsonObject[key];
                  dataList.push({column:key,row:value});
                }
              }
            }
          this.storage.set("_storedRecord",{dataList,"keyvalue":data.user_list[0]});
          this.router.navigateByUrl(page);
          console.log("page",page);

      }


    }
  );
}
getname(event){
  this.userFilter.Bank_Name = event.target.value;
}
getFin(event){
this.userFilter.agentName = event.target.value;
}
getPass(event){
this.userFilter.Customer_Name = event.target.value;
}
getAcc(event){
this.userFilter.passport_no = event.target.value;
}
getAgg(event){
this.userFilter.cif = event.target.value;
}
getCif(event){
this.userFilter.acc_no = event.target.value;
}

getOTS(event){
this.userFilter.ptp_amount = event.target.value;
}
getnat(event){
this.userFilter.ptp_status = event.target.value;
}
getcycle(event){
this.userFilter.log_date = event.target.value;
}
getflow(event){
this.userFilter.mstatus = event.target.value;
}

getData(){
  // this._api.getDashboardCount(data).subscribe(data=>{
  //   if (data['Code'] == 200) {
  //     this.DashboardData = data['Data'];
  //     console.log(this.DashboardData);

  //   } else {
  //     this.DashboardData = [];
  //   }
  // });

}


}
